<template>
  <transition name="modal">
    <div v-if="active" class="modal-mask" @click="close()">
      <div
        ref="signupmodalwrapper"
        class="modal__body qes-modal-body modal-container home-email-modal modal-wrapper"
        style="background: none"
        role="dialog"
        aria-label="Rare finds, and the stories behind them. Delivered to your inbox daily."
        analytics-track="quickregPrompt"
      >
        <div
          id="modal10pc"
          style="margin: 0 auto"
          @keyup.esc="close()"
          @click.stop
        >
          <div id="modal10pc-close" @click="close()" @keydown.esc="close()">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NC4yNDMiIGhlaWdodD0iNTQuMjQzIiB2aWV3Qm94PSIwIDAgNTQuMjQzIDU0LjI0MyI+DQogIDxnIGlkPSJHcm91cF8xNCIgZGF0YS1uYW1lPSJHcm91cCAxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3Ljg3OSAtNDcuODc5KSI+DQogICAgPGcgaWQ9Ikdyb3VwXzgiIGRhdGEtbmFtZT0iR3JvdXAgOCI+DQogICAgICA8bGluZSBpZD0iTGluZV8xIiBkYXRhLW5hbWU9IkxpbmUgMSIgeDI9IjUwIiB5Mj0iNTAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUwIDUwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS13aWR0aD0iMyIvPg0KICAgICAgPGxpbmUgaWQ9IkxpbmVfMiIgZGF0YS1uYW1lPSJMaW5lIDIiIHgxPSI1MCIgeTI9IjUwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MCA1MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjMiLz4NCiAgICA8L2c+DQogIDwvZz4NCjwvc3ZnPg0K"
            />
          </div>
          <h4>Thank you for Signing Up!</h4>
          <p style="margin-bottom: 90px">
            Enjoy exploring our wines. If you ever need assistance, drop us a
            line at
            <a :href="`mailto:${metadata.customerService.email}`">{{
              metadata.customerService.email
            }}</a
            >.
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['closed'],
  created() {
    this.metadata = useMetadata()
  },
  methods: {
    close() {
      if (this.$refs.signupmodalwrapper) {
        this.$refs.signupmodalwrapper.setAttribute('aria-hidden', 'true')
      }
      this.$emit('closed')
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/components/wineTrailThankYou/wine-trail-thank-you.scss';
</style>
